import React, { useEffect, useState } from "react";
import moment from "moment";
import styles from "../PreviewV3.module.css";
import AttachmentPreviewModal from "./AttachmentPreviewModal";

export default function DocumentProjectDetailsSection({ sectionData, displayName, sectionNumber, targetId }) {
  const safeSectionData = sectionData || {};
  const orgDetails = safeSectionData.org_details || {};

  const clientDetails = safeSectionData.client_details || {};
  const companyDetails = safeSectionData.company_details || {};
  const filesPath = orgDetails.files_path ? `${orgDetails.files_path}/` : "";
  const attachments = safeSectionData.attachments || { toggle: 0, value: [] };

  const swmsVersion = safeSectionData.swms_version;
  const versionNumber = (swmsVersion && swmsVersion.slice(1)) || 1;

  return (
    <div className={styles.PreviewSectionBlock} id={targetId} style={{ scrollMarginTop: "140px" }}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewSectionSubHead}>Document Details</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>SWMS Name</span>
                <span className={styles.PreviewValue}>{safeSectionData.swms_name}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>SWMS No.</span>
                <span className={styles.PreviewValue}>{safeSectionData.swms_number}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Revision</span>
                <span className={styles.PreviewValue}>{versionNumber}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Issue Date</span>
                <span className={styles.PreviewValue}>{moment.utc(safeSectionData.issue_date).format("DD/MM/YYYY")}</span>
              </td>

            </tr>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Job Id</span>
                <span className={styles.PreviewValue}>{safeSectionData.job_number}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>PO / WO</span>
                <span className={styles.PreviewValue}>{safeSectionData.po_number || "—"}</span>
              </td>
              <td colSpan={2}>
                <span className={styles.PreviewLabel}>Site Name</span>
                <span className={styles.PreviewValue}>{safeSectionData.site_name || "—"}</span>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <span className={styles.PreviewLabel}>Site Address</span>
                <span className={styles.PreviewValue}>{safeSectionData.site_address || "—"}</span>
              </td>
            </tr>
          </tbody>
        </table>

        {safeSectionData.scope_of_work && safeSectionData.scope_of_work.toggle === 1 && (
          <>
            <div className={styles.PreviewSectionSubHead}>Scope of Work</div>
            <div className={styles.PreviewPadding}>{safeSectionData.scope_of_work.value || "—"}</div>
          </>
        )}

        {safeSectionData.qli_areas && safeSectionData.qli_areas.toggle === 1 && (
          <>
            <div className={styles.PreviewSectionSubHead}>QLI Areas</div>
            <div className={styles.PreviewPadding}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {((safeSectionData.qli_areas && safeSectionData.qli_areas.value) || []).map((qliArea) => (
                  <span key={qliArea.id} className={styles.PreviewChip}>{qliArea && qliArea.display_name}</span>
                ))}
              </div>
            </div>
          </>
        )}

        {safeSectionData.areas && safeSectionData.areas.toggle === 1 && (
          <>
            <div className={styles.PreviewSectionSubHead}>Work Areas</div>
            <div className={styles.PreviewPadding}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {((safeSectionData.areas && safeSectionData.areas.values) || []).map((workArea, index) => (
                  <span key={index} className={styles.PreviewChip}>{workArea}</span>
                ))}
              </div>
            </div>
          </>
        )}

        {attachments && attachments.toggle === 1 && (
          <TaskAttachments attachments={attachments.value} filesPath={filesPath} />
        )}

        <div>
          <div className={styles.PreviewSectionSubHead}>Company Details</div>
          <table className={styles.PreviewTable}>
            <tbody>
              <tr>
                <td>
                  <span className={styles.PreviewLabel}>Company Name</span>
                  <span className={styles.PreviewValue}>{companyDetails.company_name}</span>
                </td>
                <td>
                  <span className={styles.PreviewLabel}>ABN</span>
                  <span className={styles.PreviewValue}>{companyDetails.company_abn}</span>
                </td>
                <td>
                  <span className={styles.PreviewLabel}>Email</span>
                  <span className={styles.PreviewValue}>{companyDetails.company_email}</span>
                </td>
                <td>
                  <span className={styles.PreviewLabel}>Phone</span>
                  <span className={styles.PreviewValue}>{companyDetails.company_phone}</span>
                </td>
              </tr>

              <tr>
                <td colSpan={2}>
                  <span className={styles.PreviewLabel}>Address</span>
                  <span className={styles.PreviewValue}>{companyDetails.company_address}</span>
                </td>
                <td colSpan={2}>
                  <span className={styles.PreviewLabel}>Website</span>
                  <span className={styles.PreviewValue}>{companyDetails.company_website}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <div className={styles.PreviewSectionSubHead}>Client Details</div>
          <table className={styles.PreviewTable}>
            <tbody>
              <tr>
                <td>
                  <span className={styles.PreviewLabel}>Client Company</span>
                  <span className={styles.PreviewValue}>{clientDetails.client_name}</span>
                </td>
                <td>
                  <span className={styles.PreviewLabel}>ABN</span>
                  <span className={styles.PreviewValue}>{clientDetails.client_abn}</span>
                </td>
                <td colSpan={2}>
                  <span className={styles.PreviewLabel}>Address</span>
                  <span className={styles.PreviewValue}>{clientDetails.client_address}</span>
                </td>
              </tr>

              <tr>
                <td>
                  <span className={styles.PreviewLabel}>Representative</span>
                  <span className={styles.PreviewValue}>{clientDetails.client_contact_person_name}</span>
                </td>
                <td>
                  <span className={styles.PreviewLabel}>Email</span>
                  <span className={styles.PreviewValue}>{clientDetails.client_contact_email}</span>
                </td>
                <td>
                  <span className={styles.PreviewLabel}>Phone</span>
                  <span className={styles.PreviewValue}>{clientDetails.client_contact_phone}</span>
                </td>
                <td>
                  <span className={styles.PreviewLabel}>Position</span>
                  <span className={styles.PreviewValue}>{clientDetails.client_contact_role}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>
  )
}

const TaskAttachments = ({ attachments, filesPath }) => {

  const [preview, setPreview] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);

  useEffect(() => {
    if (preview) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [preview]);

  const FILE_ICON_PATHS = {
    pdf: "M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L208 576L208 464C208 428.7 236.7 400 272 400L448 400L448 234.5C448 217.5 441.3 201.2 429.3 189.2L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM272 444C261 444 252 453 252 464L252 592C252 603 261 612 272 612C283 612 292 603 292 592L292 564L304 564C337.1 564 364 537.1 364 504C364 470.9 337.1 444 304 444L272 444zM304 524L292 524L292 484L304 484C315 484 324 493 324 504C324 515 315 524 304 524zM400 444C389 444 380 453 380 464L380 592C380 603 389 612 400 612L432 612C460.7 612 484 588.7 484 560L484 496C484 467.3 460.7 444 432 444L400 444zM420 572L420 484L432 484C438.6 484 444 489.4 444 496L444 560C444 566.6 438.6 572 432 572L420 572zM508 464L508 592C508 603 517 612 528 612C539 612 548 603 548 592L548 548L576 548C587 548 596 539 596 528C596 517 587 508 576 508L548 508L548 484L576 484C587 484 596 475 596 464C596 453 587 444 576 444L528 444C517 444 508 453 508 464z",
    word: "M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 64 374.8 70.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM263.4 338.8C260.5 325.9 247.7 317.7 234.8 320.6C221.9 323.5 213.7 336.3 216.6 349.2L248.6 493.2C250.9 503.7 260 511.4 270.8 512C281.6 512.6 291.4 505.9 294.8 495.6L320 419.9L345.2 495.6C348.6 505.8 358.4 512.5 369.2 512C380 511.5 389.1 503.8 391.4 493.2L423.4 349.2C426.3 336.3 418.1 323.4 405.2 320.6C392.3 317.8 379.4 325.9 376.6 338.8L363.4 398.2L342.8 336.4C339.5 326.6 330.4 320 320 320C309.6 320 300.5 326.6 297.2 336.4L276.6 398.2L263.4 338.8z",
    sheet: "M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L208 576L208 464C208 428.7 236.7 400 272 400L448 400L448 234.5C448 217.5 441.3 201.2 429.3 189.2L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM296 444C271.7 444 252 463.7 252 488L252 568C252 592.3 271.7 612 296 612L312 612C336.3 612 356 592.3 356 568L356 560C356 549 347 540 336 540C325 540 316 549 316 560L316 568C316 570.2 314.2 572 312 572L296 572C293.8 572 292 570.2 292 568L292 488C292 485.8 293.8 484 296 484L312 484C314.2 484 316 485.8 316 488L316 496C316 507 325 516 336 516C347 516 356 507 356 496L356 488C356 463.7 336.3 444 312 444L296 444zM432 444C403.3 444 380 467.3 380 496C380 524.7 403.3 548 432 548C438.6 548 444 553.4 444 560C444 566.6 438.6 572 432 572L400 572C389 572 380 581 380 592C380 603 389 612 400 612L432 612C460.7 612 484 588.7 484 560C484 531.3 460.7 508 432 508C425.4 508 420 502.6 420 496C420 489.4 425.4 484 432 484L456 484C467 484 476 475 476 464C476 453 467 444 456 444L432 444zM528 444C517 444 508 453 508 464L508 495.6C508 531.1 518.5 565.9 538.2 595.4L543.3 603.1C547 608.7 553.3 612 559.9 612C566.5 612 572.8 608.7 576.5 603.1L581.6 595.4C601.3 565.8 611.8 531.1 611.8 495.6L611.8 464C611.8 453 602.8 444 591.8 444C580.8 444 571.8 453 571.8 464L571.8 495.6C571.8 515.2 567.7 534.5 559.8 552.3C551.9 534.5 547.8 515.2 547.8 495.6L547.8 464C547.8 453 538.8 444 527.8 444z",
    other: "M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L308 576C285.3 544.5 272 505.8 272 464C272 363.4 349.4 280.8 448 272.7L448 234.6C448 217.6 441.3 201.3 429.3 189.3L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM464 608C543.5 608 608 543.5 608 464C608 384.5 543.5 320 464 320C384.5 320 320 384.5 320 464C320 543.5 384.5 608 464 608zM464 508C475 508 484 517 484 528C484 539 475 548 464 548C453 548 444 539 444 528C444 517 453 508 464 508zM464 408C452.4 408 442.7 416.2 440.5 427.2C438.7 435.9 430.3 441.5 421.6 439.7C412.9 437.9 407.3 429.5 409.1 420.8C414.3 395.2 436.9 376 464 376C494.9 376 520 401.1 520 432C520 451.8 508.3 469.8 490.2 477.9L479.8 482.5C478.6 490.2 472 496 464 496C455.2 496 448 488.8 448 480C448 468.8 454.6 458.7 464.8 454.1L477.2 448.6C483.8 445.7 488 439.2 488 432C488 418.7 477.3 408 464 408z",
  };

  const normalizedAttachments = Array.isArray(attachments)
    ? attachments
      .map((item, index) => {
        const fileMeta = (item && item.file_name) || {};
        const rawPath = fileMeta.file_name || "";
        const path = `${rawPath}`.trim();

        if (!path) {
          return null;
        }

        const visibleName = fileMeta.visible_name || path.split("/").pop() || `attachment-${index + 1}`;
        const mimeType = `${fileMeta.type || ""}`.toLowerCase();
        const extension = (visibleName.split(".").pop() || "").toLowerCase();
        const note = `${(item && item.note) || ""}`.trim();

        const encodedPath = path
          .split("/")
          .map((segment) => encodeURIComponent(segment))
          .join("/");

        const basePath = `${filesPath || ""}`.replace(/\/+$/, "");
        const relativePath = encodedPath.replace(/^\/+/, "");
        const fileUrl = /^(https?:)?\/\//i.test(path)
          ? path
          : `${basePath}/${relativePath}`;

        const isImage = mimeType.startsWith("image/")
          || ["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"].includes(extension);

        const isPdf = mimeType.includes("pdf") || extension === "pdf";

        let fileTypeLabel = "FILE";
        let iconKind = "other";

        if (mimeType.includes("pdf") || extension === "pdf") {
          fileTypeLabel = "PDF";
          iconKind = "pdf";
        } else if (mimeType.includes("word") || extension === "doc" || extension === "docx") {
          fileTypeLabel = extension.toUpperCase() || "DOC";
          iconKind = "word";
        } else if (["csv", "xls", "xlsx", "xsl", "xslx"].includes(extension)
          || mimeType.includes("csv")
          || mimeType.includes("spreadsheet")
          || mimeType.includes("excel")) {
          fileTypeLabel = (extension || "CSV").toUpperCase();
          iconKind = "sheet";
        } else if (isImage) {
          fileTypeLabel = (extension || mimeType.split("/")[1] || "IMG").toUpperCase();
        } else if (extension) {
          fileTypeLabel = extension.toUpperCase();
        }

        return {
          key: `${path}-${index}`,
          fileUrl,
          visibleName,
          note,
          isImage,
          isPdf,
          fileTypeLabel,
          iconKind,
        };
      })
      .filter(Boolean)
    : [];

  return (
    <>
      <div className={styles.PreviewSectionSubHead}>Task Photos & Attachments</div>
      <div className={styles.PreviewGallery}>
        {normalizedAttachments.length === 0 ? (
          <div className={styles.PreviewPadding}>No attachments added.</div>
        ) : normalizedAttachments.map((attachment, index) => (
          <div
            key={attachment.key}
            className={styles.PreviewPhoto}
            title={attachment.visibleName}
            onClick={() => {
              setPreviewIndex(index);
              setPreview(true);
            }}
          >
            {attachment.isImage ? (
              <div className={styles.PreviewPhotoImage} style={{ position: "relative" }} onClick={() => setPreview(true)}>
                <img
                  src={attachment.fileUrl}
                  alt={attachment.note || attachment.visibleName}
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                  }}
                />
              </div>
            ) : (
              <div className={styles.PreviewPhotoDoc}>
                <svg fill="currentColor" width="26px" height="26px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true">
                  <path d={FILE_ICON_PATHS[attachment.iconKind] || FILE_ICON_PATHS.other} />
                </svg>
                <span>{attachment.fileTypeLabel}</span>
              </div>
            )}

            <div className={styles.PreviewPhotoZoomIcon}>
              <svg style={{ height: "12px", width: "12px" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true">
                <path fill="currentColor" d="M128 96C110.3 96 96 110.3 96 128L96 224C96 241.7 110.3 256 128 256C145.7 256 160 241.7 160 224L160 160L224 160C241.7 160 256 145.7 256 128C256 110.3 241.7 96 224 96L128 96zM160 416C160 398.3 145.7 384 128 384C110.3 384 96 398.3 96 416L96 512C96 529.7 110.3 544 128 544L224 544C241.7 544 256 529.7 256 512C256 494.3 241.7 480 224 480L160 480L160 416zM416 96C398.3 96 384 110.3 384 128C384 145.7 398.3 160 416 160L480 160L480 224C480 241.7 494.3 256 512 256C529.7 256 544 241.7 544 224L544 128C544 110.3 529.7 96 512 96L416 96zM544 416C544 398.3 529.7 384 512 384C494.3 384 480 398.3 480 416L480 480L416 480C398.3 480 384 494.3 384 512C384 529.7 398.3 544 416 544L512 544C529.7 544 544 529.7 544 512L544 416z" />
              </svg>
            </div>

            <div className={styles.PreviewPhotoCaption}>
              <div className={styles.PreviewPhotoCaptionText}>{attachment.note || attachment.visibleName}</div>
              <div className={styles.PreviewPhotoCaptionSubText}>{attachment.fileTypeLabel}</div>
            </div>
          </div>
        ))}
      </div>

      <AttachmentPreviewModal
        isOpen={preview}
        onClose={() => setPreview(false)}
        attachments={normalizedAttachments}
        currentIndex={previewIndex}
        onNextClick={() =>
          setPreviewIndex(previewIndex === normalizedAttachments.length - 1 ? 0 : previewIndex + 1)
        }
        onPrevClick={() =>
          setPreviewIndex(previewIndex === 0 ? normalizedAttachments.length - 1 : previewIndex - 1)
        }
        fileIconPaths={FILE_ICON_PATHS}
      />
    </>
  )
}
